export const pageTitle = (title) => {
  return (document.title = title + " -  Ак Аю - Многопрофильная клиника");
};
